import React from 'react';
import SliderHome from 'components/Components/Sections/SliderHome';
import Fade from 'react-reveal/Fade';
import Services from 'components/Components/Sections/Services';

const HomeCover = props => (
    <div>
        {/* Jumbo Banner Section */}
        <SliderHome />

        {/* Intro Section */}
        <section id="intro" className="tw-py-10 lg:tw-py-20 tw-px-4">
            <div className="xl:tw-container tw-text-center">
                <Fade bottom>
                    <div className="tw-flex tw-flex-wrap lg:tw-justify-center">
                        <div className="tw-w-full lg:tw-w-1/2 xl:tw-w-2/5">
                            <h1 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">About Us</h1>
                        </div>
                    </div>
                </Fade>
                <Fade bottom>
                    <div className="tw-border-b-2 tw-border-gray-500 tw-my-12 tw-w-56 tw-mx-auto" />
                </Fade>
                <Fade bottom>
                    <h2 className="tw-uppercase font-sp">Personalized Hand-Crafted Luxury Experiences</h2>
                </Fade>
                <Services />
            </div>
        </section>
    </div>
);

HomeCover.propTypes = {

};

export default HomeCover;
